(() => {
  'use strict';
  const init = root => {
    if (!root || root.dataset.hghReady) return;
    root.dataset.hghReady = 'true';
    const cleanups = [];
    const listen = (target, event, fn, options) => {
      target.addEventListener(event, fn, options);
      cleanups.push(() => target.removeEventListener(event, fn, options));
    };
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const menu = root.querySelector('.hgh-mobile-nav');
    const toggle = root.querySelector('.hgh-menu-toggle');
    const setMenu = open => {
      menu.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    };
    if (toggle && menu) {
      toggle.hidden = false;
      setMenu(false);
      listen(toggle, 'click', () => setMenu(menu.hidden));
      listen(menu, 'click', event => { if (event.target.closest('a')) setMenu(false); });
      listen(root, 'keydown', event => {
        if (event.key === 'Escape' && !menu.hidden) { setMenu(false); toggle.focus(); }
      });
      const mobile = matchMedia('(max-width: 749px)');
      listen(mobile, 'change', () => setMenu(false));
    }
    root.querySelectorAll('[data-hgh-ingredients] details').forEach(details => {
      listen(details, 'toggle', () => {
        if (details.open) root.querySelectorAll('[data-hgh-ingredients] details').forEach(other => {
          if (other !== details) other.open = false;
        });
      });
    });
    const reveals = [...root.querySelectorAll('[data-hgh-reveal]')];
    if ('IntersectionObserver' in window) {
      // Content is visible by default, including with JavaScript disabled.
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.add('is-revealed'); observer.unobserve(entry.target); }
      }), { threshold: 0.08, rootMargin: '0px 0px 25px' });
      reveals.forEach(el => {
        if (el.getBoundingClientRect().top < innerHeight) el.classList.add('is-revealed');
        else observer.observe(el);
      });
      root.classList.add('is-enhanced');
      cleanups.push(() => observer.disconnect());
    }
    const scenes = [...root.querySelectorAll('[data-hgh-scene], .hgh-ticker')];
    const visibleScenes = new Set();
    let frame = 0;
    const paint = () => {
      frame = 0;
      if (reduced.matches || document.hidden) return;
      visibleScenes.forEach(el => {
        const bounds = el.getBoundingClientRect();
        const progress = Math.max(-1, Math.min(1, (innerHeight / 2 - bounds.top - bounds.height / 2) / innerHeight));
        el.style.setProperty('--hgh-scroll', progress.toFixed(3));
      });
    };
    const schedule = () => { if (!frame && !reduced.matches && !document.hidden && visibleScenes.size) frame = requestAnimationFrame(paint); };
    if ('IntersectionObserver' in window) {
      const sceneObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          entry.target.classList.toggle('is-in-view', entry.isIntersecting);
          if (entry.isIntersecting) visibleScenes.add(entry.target);
          else visibleScenes.delete(entry.target);
        });
        schedule();
      });
      scenes.forEach(el => sceneObserver.observe(el));
      cleanups.push(() => sceneObserver.disconnect());
    }
    listen(window, 'scroll', schedule, { passive: true });
    listen(window, 'resize', schedule, { passive: true });
    const visibility = () => {
      root.classList.toggle('is-paused', document.hidden || reduced.matches);
      if (document.hidden || reduced.matches) { cancelAnimationFrame(frame); frame = 0; }
      else schedule();
    };
    listen(document, 'visibilitychange', visibility);
    listen(reduced, 'change', visibility);
    visibility();
    const unload = event => {
      if (!event.target.contains(root)) return;
      cleanups.forEach(cleanup => cleanup());
      cancelAnimationFrame(frame);
      document.removeEventListener('shopify:section:unload', unload);
    };
    document.addEventListener('shopify:section:unload', unload);
  };
  document.querySelectorAll('[data-gummies-home]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-gummies-home]').forEach(init));
})();
